module.exports = "/_next/static/images/screen-1-55ea24cbeb26a1a2647251cb367e93fe.jpg.webp";